// Central visual + copy data for Livinora
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1800&q=80",
  heroAlt: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
  intro: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  ferienhaus: "https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1400&q=80",
  ferienwohnung: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  apartment: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1400&q=80",
  refit: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1400&q=80",
  individualization: "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?auto=format&fit=crop&w=1400&q=80",
  commercial: "https://images.unsplash.com/photo-1582037928769-181f2644ecb7?auto=format&fit=crop&w=1400&q=80",
  brochure: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1400&q=80",
  textureWood: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=1200&q=80",
  textureStone: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=80",
  quietDetail: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1200&q=80",
  kitchen: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
};

export const STYLE_SERIES = [
  {
    slug: "kueste",
    name: "Küste",
    tagline: "Licht, Leinen, Horizont.",
    description:
      "Eine zurückhaltende Küstenhandschrift: gebleichte Hölzer, Leinenstrukturen, sanftes Tageslicht. Für Objekte, in denen der Blick nach draußen erzählen soll.",
    materials: ["Eiche gekalkt", "Leinen natur", "Keramik sand", "Travertin"],
    palette: ["#EFE9DF", "#CDC2AE", "#8A8778", "#1F1E1C"],
    suitedFor: ["Ferienhaus", "Ferienwohnung"],
    image:
      "https://images.unsplash.com/photo-1499916078039-922301b0eb9b?auto=format&fit=crop&w=1600&q=80",
    imageDetail:
      "https://images.unsplash.com/photo-1541123437800-1bb1317badc2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "alpin",
    name: "Alpin",
    tagline: "Holz, Stein, Ruhe.",
    description:
      "Eine moderne Interpretation alpiner Architektur. Warme Massivhölzer, präzise Linien, ehrliche Materialien — ohne Chalet-Klischee.",
    materials: ["Lärche geräuchert", "Wollfilz", "Naturstein grob", "Leder cognac"],
    palette: ["#EDE6D9", "#A89478", "#5C4A36", "#1A1816"],
    suitedFor: ["Ferienhaus", "Refit"],
    image:
      "https://images.pexels.com/photos/12404352/pexels-photo-12404352.jpeg?auto=compress&cs=tinysrgb&w=1600",
    imageDetail:
      "https://images.unsplash.com/photo-1542718610-a1d656d1884c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "skandi",
    name: "Skandi",
    tagline: "Klarheit, Wärme, Maß.",
    description:
      "Skandinavische Klarheit trifft auf weiche Materialität. Reduziertes Möbelbild, warme Töne, ein konzentriertes Raumgefühl für entspannte Aufenthalte.",
    materials: ["Esche weiß geölt", "Bouclé natur", "Kalkputz", "Messing matt"],
    palette: ["#F3EFE7", "#D9CFBE", "#7C7468", "#1A1A1A"],
    suitedFor: ["Ferienwohnung", "Apartment"],
    image:
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=1600&q=80",
    imageDetail:
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "landhaus-modern",
    name: "Landhaus Modern",
    tagline: "Handwerk, neu gelesen.",
    description:
      "Zeitgemäßes Landhaus ohne Nostalgie. Grobe Strukturen, ruhige Flächen, handwerkliche Details — eine Einrichtung, die Gäste im besten Sinne ankommen lässt.",
    materials: ["Eiche astig", "Naturstein gespalten", "Baumwollgewebe", "Schmiedestahl"],
    palette: ["#E9E3D4", "#B8A683", "#4E4537", "#1A1A1A"],
    suitedFor: ["Ferienhaus", "Refit"],
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=80",
    imageDetail:
      "https://images.unsplash.com/photo-1551105378-78e609e1d468?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "urban-retreat",
    name: "Urban Retreat",
    tagline: "Dicht, dunkel, kuratiert.",
    description:
      "Für Stadtapartments und Serviced-Formate: dunkle Nuancen, dichte Materialität, eine Einrichtung, die Rückzug im urbanen Kontext ermöglicht.",
    materials: ["Räuchereiche", "Mohair taupe", "Beton sichtbar", "Bronze brüniert"],
    palette: ["#EAE5DC", "#807568", "#3C352D", "#15130F"],
    suitedFor: ["Apartment", "Gewerblich"],
    image:
      "https://images.pexels.com/photos/4409370/pexels-photo-4409370.jpeg?auto=compress&cs=tinysrgb&w=1600",
    imageDetail:
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=80",
  },
];

export const PACKAGES = [
  {
    key: "basis",
    name: "Basis",
    promise: "Ein vollständiges, solides Einrichtungskonzept.",
    description:
      "Die klar strukturierte Einstiegslinie: alle essenziellen Möbel und Textilien für Schlafen, Wohnen, Kochen und Bad — stimmig aufeinander abgestimmt.",
    includes: [
      "Kern-Mobiliar aller Räume",
      "Grundtextilien & Vorhänge",
      "Basis-Leuchtenkonzept",
      "Küchen- & Bad-Ausstattung",
    ],
    suitedFor: "Objekte, die zuverlässig, klar und kosteneffizient vermietet werden sollen.",
  },
  {
    key: "komfort",
    name: "Komfort",
    promise: "Spürbar mehr Dichte, Material und Gastgefühl.",
    description:
      "Zusätzliche Ebenen an Materialität, Licht und Detail. Das Konzept, mit dem sich ein Objekt positionieren lässt — ohne in Luxus-Zitate zu kippen.",
    includes: [
      "Erweitertes Mobiliar inkl. Akzentstücke",
      "Gehobene Textilien & Teppiche",
      "Mehrschichtiges Lichtkonzept",
      "Küchen-Upgrade & Geschirrwelt",
    ],
    suitedFor: "Objekte mit klarer Vermietungsstrategie und mittlerem bis gehobenem Segment.",
  },
  {
    key: "premium",
    name: "Premium",
    promise: "Ein vollständig komponierter Raum.",
    description:
      "Die höchste Ausbaustufe: feinere Materialien, handwerklich kuratiert, mit spürbar hoher Aufenthaltsqualität — ein Objekt, das sich als Marke positionieren lässt.",
    includes: [
      "Kuratiertes Mobiliar mit Einzelstücken",
      "Designer-Leuchten & Statement-Objekte",
      "Hochwertige Stoffe, Teppiche, Decken",
      "Durchgängig gestaltete Details",
    ],
    suitedFor: "Premium-Ferienobjekte, Boutique-Formate und anspruchsvolle private Nutzung.",
  },
];

export const OBJECT_TYPES = [
  {
    slug: "ferienhaus",
    name: "Ferienhaus",
    pitch: "Ein ganzes Haus, ein ganzheitliches Konzept.",
    description:
      "Für freistehende Ferienhäuser — vom ruhigen Landhaus bis zum modernen Architektenhaus. Wir planen alle Wohnebenen im Zusammenhang.",
    highlights: ["4–12 Gäste", "Alle Wohnräume", "Garten & Außen optional"],
    image:
      "https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1400&q=80",
  },
  {
    slug: "ferienwohnung",
    name: "Ferienwohnung",
    pitch: "Kompakt, klar, gäste-tauglich.",
    description:
      "Für klassische Ferienwohnungen in Häusern, Residenzen und Anlagen. Wir optimieren Stauraum, Schlafflächen und das Zusammenspiel offener Wohnräume.",
    highlights: ["2–6 Gäste", "Optimierte Grundrisse", "Flexible Schlafformate"],
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  },
  {
    slug: "apartment",
    name: "Apartment",
    pitch: "Urban, ruhig, präzise eingerichtet.",
    description:
      "Für dauerhaft bewohnte und länger genutzte Apartments — in der Stadt oder als Zweitwohnsitz. Ruhige Materialität, klare Funktion, Langlebigkeit.",
    highlights: ["1–4 Personen", "Arbeit & Wohnen", "Dauerhafter Bezug"],
    image:
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1400&q=80",
  },
  {
    slug: "refit",
    name: "Refit",
    pitch: "Bestehendes klüger machen.",
    description:
      "Für bestehende Ferienobjekte mit veralteter Einrichtung. Wir analysieren, priorisieren und heben das Objekt in einem klaren Konzept auf ein neues Niveau.",
    highlights: ["Vollständig oder modular", "Mit oder ohne Bestandsnutzung", "Optional Vor-Ort-Aufnahme"],
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1400&q=80",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Objekttyp",
    copy: "Haus, Wohnung oder Apartment. Wir beginnen mit dem, was da ist — oder entstehen soll.",
  },
  {
    n: "02",
    title: "Stilserie",
    copy: "Fünf konsequent durchgearbeitete Welten. Jede Serie trägt ein eigenes Raumgefühl.",
  },
  {
    n: "03",
    title: "Paket",
    copy: "Basis, Komfort oder Premium — die Tiefe Ihres Konzepts, nicht der Preis entscheidet die Haltung.",
  },
  {
    n: "04",
    title: "Individualisierung",
    copy: "Standard, wo sinnvoll. Individuell, wo nötig. Konfigurator oder persönliche Planung.",
  },
];

export const FAQS = [
  {
    q: "Ist Livinora für Privatkunden oder gewerbliche Betreiber?",
    a: "Für beide. Unsere Konzepte sind so aufgebaut, dass sie für einzelne Ferienhäuser ebenso tragen wie für ganze Anlagen mit mehreren Einheiten.",
  },
  {
    q: "Kann ich nur ein einziges Ferienhaus einrichten lassen?",
    a: "Ja. Ein einzelnes Objekt ist unser häufigster Ausgangspunkt. Das Vorgehen bleibt strukturiert und klar.",
  },
  {
    q: "Können mehrere Einheiten gleichzeitig umgesetzt werden?",
    a: "Ja. Für Betreiber, Ferienparks und Projektentwickler bieten wir skalierbare Rollout-Konzepte mit konsistenter Gestaltung.",
  },
  {
    q: "Wie individuell sind die Konzepte?",
    a: "Die Stilserien geben ein klares Gestaltungsgerüst. Innerhalb dessen passen wir Maße, Zuschnitte und Akzente an Ihr Objekt an.",
  },
  {
    q: "Gibt es einen Konfigurator?",
    a: "Ja. Unser Konfigurator führt Sie in wenigen Schritten durch Objekttyp, Stilserie, Paket und Zusatzmodule.",
  },
  {
    q: "Bieten Sie Refits und Renovierungen an?",
    a: "Ja. Refit ist eine eigenständige Leistung — vollständig oder modular, mit optionaler Vor-Ort-Aufnahme.",
  },
  {
    q: "Was passiert nach meiner Anfrage?",
    a: "Sie erhalten zeitnah eine erste Rückmeldung. Wir klären Objekt, Ziele und Rahmen und entwickeln ein konkretes Konzept-Angebot.",
  },
  {
    q: "Kommt ein Planungsteam auch vor Ort?",
    a: "Auf Wunsch ja. Für besondere Grundrisse oder größere Projekte kommt unser Team zur Aufnahme und individuellen Planung.",
  },
  {
    q: "Eignet sich Livinora für Betreiber oder Entwickler?",
    a: "Ja, ausdrücklich. Unsere Logik ist auf wiederholbare Qualität, konsistente Gestaltung und effiziente Umsetzung ausgelegt.",
  },
  {
    q: "Kann ich Broschüren herunterladen?",
    a: "Ja. Broschüre und Stilserien-Übersicht stehen als PDF zur Verfügung.",
  },
  {
    q: "Wie verbindlich ist der Konfigurator?",
    a: "Der Konfigurator bildet Ihre Auswahl ab. Er ist ein Ausgangspunkt für Ihr Projekt — kein starres Angebot.",
  },
  {
    q: "Kann ein Konzept später angepasst werden?",
    a: "Ja. Konzepte sind darauf ausgelegt, perspektivisch erweiterbar und modifizierbar zu bleiben.",
  },
];

export const AUDIENCE_COPY = {
  privat: {
    heroHeadline: "Schlüsselfertige Einrichtungskonzepte für Ferienobjekte und Apartments.",
    heroSub:
      "Livinora verbindet Stilserien, Ausstattungspakete und Raumsets zu einem strukturierten Weg von der Idee bis zur bezugsfertigen Einrichtung.",
    primaryCTA: "Projekt konfigurieren",
    primaryHref: "/konfigurator",
    secondaryCTA: "Raumsets ansehen",
    secondaryHref: "/shop",
    quietCTA: "Nora fragen",
    focus: "Konzept · Stilserie · Paket · Anfrage",
  },
  gewerblich: {
    heroHeadline: "Konsistente Einrichtungen für mehrere Einheiten.",
    heroSub:
      "Skalierbare Konzepte für Ferienparks, Apartmentbetreiber und Projektentwickler — wiederholbar in Qualität, differenziert in Ausprägung.",
    primaryCTA: "Projekt konfigurieren",
    primaryHref: "/konfigurator",
    secondaryCTA: "Raumsets ansehen",
    secondaryHref: "/shop",
    quietCTA: "Nora fragen",
    focus: "System · Stilserie · Paket · Rollout",
  },
};
